// pauses the activity.  Passed into props of each container.
import {
  PAUSE_ACTIVITY,
  RESUME_ACTIVITY
} from '../actions'

export default function paused (state = false, action) {
  switch (action.type) {
    case PAUSE_ACTIVITY:
      return true
    case RESUME_ACTIVITY:
      return false
    default:
      return state
  }
}
